import { useEffect, useState } from "react";

import { classNameGenerator } from "@/utils";

import styles from "./OfferCounter.module.scss";
import Typography from "@/foundation/Typography/V2";

interface OfferCounterProps {
  offerEndDate?: string;
  offerTextSecondPart?: string;
  offerTextFirstPart?: string;
}

const OfferCounter: React.FC<OfferCounterProps> = ({
  offerTextFirstPart,
  offerTextSecondPart,
  offerEndDate = "2023-11-12",
}) => {
  const [dateData, setdateData] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const calculateDateDifference = () => {
    // Parse the future date string into a Date object
    const futureDate = new Date(offerEndDate);

    // Get the current date and time
    const currentDate = new Date();

    // Calculate the time difference in milliseconds

    const timeDifference = futureDate - currentDate;

    // Calculate days, hours, minutes, and seconds
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor(
      (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
    );
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    setdateData({ days, hours, minutes, seconds });
  };
  useEffect(() => {
    calculateDateDifference();
    const intervalId = setInterval(calculateDateDifference, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const cls = classNameGenerator(styles);
  const { days, hours, minutes, seconds } = dateData;
  return (
    <div className={cls("OfferCounter")}>
      <div className={cls("leftPart")}>
        <Typography variant="paragraph4">{offerTextFirstPart}</Typography>
        <Typography variant="paragraph4">{offerTextSecondPart}</Typography>
      </div>
      <div className={cls("rightPart")}>
        <div className={cls("rightPartItem")}>
          <Typography variant="paragraph4">{days}</Typography>
          <Typography variant="paragraph4">D</Typography>
        </div>
        <div className={cls("rightPartItem")}>
          <Typography variant="paragraph4">{hours}</Typography>
          <Typography variant="paragraph4">H</Typography>
        </div>
        <div className={cls("rightPartItem")}>
          <Typography variant="paragraph4">{minutes}</Typography>
          <Typography variant="paragraph4">M</Typography>
        </div>
        <div className={cls("rightPartItem")}>
          <Typography variant="paragraph4">{seconds}</Typography>
          <Typography variant="paragraph4">S</Typography>
        </div>
      </div>
    </div>
  );
};

export default OfferCounter;
